import { BrowserRouter as Router } from 'react-router-dom';
import { styled } from 'styled-components';
import './App.css';
import { AppRoutes } from './router';

function App() {
  return (
    <AppContainer>
      <Router>
        <AppRoutes />
      </Router>
    </AppContainer>
  );
}

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export default App;
